import { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config";

export default function MaintenanceMailStatus() {

    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    // ✅ Convert UTC to IST
    const formatIST = (utcString) => {
        if (!utcString) return "-";

        return new Date(utcString).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    const loadLogs = async () => {
        try {
            const res = await axios.get(
                `${API_BASE_URL}/api/maintenance/mail-logs`
            );

            setRows(res.data?.data || []);
        } catch (err) {
            console.error("Failed to load mail logs", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadLogs();
    }, []);

    return (
        <div>

            <h2 style={{ marginBottom: 16 }}>
                Maintenance Mail Logs
            </h2>

            {loading ? (
                <p>Loading...</p>
            ) : (
                <div style={{ overflowX: "auto" }}>
                    <table
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            background: "#fff"
                        }}
                    >
                        <thead>
                            <tr style={{ background: "#f8fafc" }}>
                                <th style={th}>Name</th>
                                <th style={th}>Email</th>
                                <th style={th}>Sent Date (IST)</th>
                                <th style={th}>Received Status</th>
                            </tr>
                        </thead>

                        <tbody>
                            {rows.length === 0 && (
                                <tr>
                                    <td colSpan="4" style={emptyCell}>
                                        No mail logs found
                                    </td>
                                </tr>
                            )}

                            {rows.map((row) => (
                                <tr key={row._id}>
                                    <td style={td}>{row.name}</td>
                                    <td style={td}>{row.email}</td>
                                    <td style={td}>
                                        {formatIST(row.sentAtUtc)}
                                    </td>
                                    <td
                                        style={{
                                            ...td,
                                            fontWeight: 600,
                                            color:
                                                row.receivedStatus === "SENT"
                                                    ? "#16a34a"
                                                    : "#dc2626"
                                        }}
                                    >
                                        {row.receivedStatus}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

        </div>
    );
}

/* simple styles */
const th = {
    border: "1px solid #e5e7eb",
    padding: "10px",
    textAlign: "left",
    fontWeight: 600,
    fontSize: 14
};

const td = {
    border: "1px solid #e5e7eb",
    padding: "10px",
    fontSize: 14
};

const emptyCell = {
    padding: "20px",
    textAlign: "center",
    color: "#6b7280"
};
